import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const cleanUrl = (url: string) => {
  if (!url) return '';
  
  try {
    // Handle relative URLs
    if (!url.match(/^[a-zA-Z]+:\/\//)) {
      url = window.location.origin + (url.startsWith('/') ? url : '/' + url);
    }
    
    // Parse URL to handle all parts correctly
    const parsed = new URL(url);
    
    // Clean the pathname of multiple slashes
    parsed.pathname = '/' + parsed.pathname.split('/').filter(Boolean).join('/');
    
    // Ensure single slash between parts
    return parsed.toString().replace(/([^:]\/)\/+/g, '$1');
  } catch (e) {
    // For invalid URLs, do basic cleanup
    return url.replace(/([^:]\/)\/+/g, '$1').replace(/\\/g, '/');
  }
};

export const safeMutationObserver = (
  node: Element | null,
  callback: MutationCallback,
  options: MutationObserverInit
) => {
  if (!node || !(node instanceof Node)) {
    console.warn('[safeMutationObserver] Invalid node provided, skipping observation');
    return null;
  }
  
  try {
    const observer = new MutationObserver(callback);
    observer.observe(node, options);
    return observer;
  } catch (error) {
    console.error('[safeMutationObserver] Error creating observer:', error);
    return null;
  }
};